import React, { useEffect, useRef } from "react"

import { FlashPlayer } from "@shared/components"
import { useLayerPopupContext, useSchedule } from "@shared/contexts"
import { createFlashPlayer } from "@shared/modules"
import { playerService } from "@shared/services"

import { Player } from "live/modules"

interface Props {
  player: Player | undefined
  setPlayer: Function
  handleFullMode: Function
}

export default function LiveFlashPlayer({
  player,
  setPlayer,
  handleFullMode,
}: Props) {
  const { video } = useLayerPopupContext()
  const { schedule } = useSchedule()

  const playerRef = useRef<HTMLDivElement>(null)

  const streamingStatus = schedule?.streamingStatus
  const streamHost = schedule?.streamHost
  const applicationId = schedule?.applicationId
  const streamKey = schedule?.streamKey

  const displayRatio = video.size

  useEffect(() => {
    if (
      !playerRef.current ||
      !streamHost ||
      !applicationId ||
      !streamKey ||
      player
    )
      return
    ;(async () => {
      setPlayer(
        await createFlashPlayer(
          playerRef.current!,
          {
            domain: streamHost,
            application: applicationId,
            streamkey: await playerService.getStreamingUrl(streamKey, "LIVE"),
          },
          handleFullMode,
        ),
      )
    })()
  }, [player, setPlayer, handleFullMode, streamHost, applicationId, streamKey])

  useEffect(() => {
    if (!player || !streamHost || !applicationId || !streamKey) return
    ;(async () => {
      player.setStreamURL({
        domain: streamHost,
        application: applicationId,
        streamkey: await playerService.getStreamingUrl(streamKey, "LIVE"),
      })
    })()
  }, [player, streamHost, applicationId, streamKey])

  useEffect(() => {
    if (!player || !streamingStatus) return

    switch (streamingStatus) {
      case "START":
        player.start()
        break
      case "END":
        player.stop()
        break
    }
  }, [player, streamingStatus])

  useEffect(() => {
    if (!player) return

    player.changeDisplayRatio!(displayRatio)
  }, [player, displayRatio])

  return <FlashPlayer playerRef={playerRef} />
}
